module.exports = __webpack_public_path__ + "static/Averta-Semibold-9e5d23ccc1dade809e2708adb3515806.ttf";